<template>
    <div class="box">

        <img class="banner" src="/subject/frendbonst/function/banner.png" @click="joinActivity" alt="" />

        <img src="/subject/frendbonst/function/rule.png" class="rule" @click="controlPop = true" alt="">


        <div class="content">
            <div class="part">
                <img class="carts" src="/subject/frendbonst/function/cart.png" alt="" />
                <div class="cart1">
                    <img v-if="inviteType == 1" @click="changeType()" class="recommen"
                        src="/subject/frendbonst/function/recommend.png" alt="" />
                    <img v-else class="recommen" @click="changeType()"
                        src="/subject/frendbonst/function/recommonder.png" alt="" />
                    <div class="invitecont" v-if="inviteType == 1">
                        <p>邀请码</p>
                        <input class="invitecode" v-model="inviteeCode" type="text" placeholder="请输入好友邀请码">
                        <img src="/subject/frendbonst/function/button.png" @click="bindFriend" alt="">
                        <div class="tips">
                            *确认与该好友绑定后，则无法与其他好友建立绑定关系
                        </div>
                    </div>
                    <div class="inviteconts" v-else>

                        <div class="invitercont">
                            我的邀请链接
                            <input class="invitecode" id="link" v-model="inviteLink" type="text" placeholder="请输入邀请链接">
                            <img class="copy" @click="copyChange(1)" src="/subject/frendbonst/function/copy.png" alt="">
                        </div>
                        <div class="invitercont">
                            我的邀请码
                            <input class="invitecode inviter" id="code" v-model="inviteCode" type="text"
                                placeholder="请输入邀请码">
                            <img class="copy" @click="copyChange(2)" src="/subject/frendbonst/function/copy.png" alt="">

                        </div>
                        <img @click="createPoster" src="/subject/frendbonst/function/button1.png" alt="">
                    </div>
                </div>
                <div class="cart2">
                    <img src="/subject/frendbonst/function/reward.png" class="rule" alt="">
                    <div class="ledgers">
                        <div>
                            <span class="tit">{{ rewardInfo.effectivenum || 0 }}</span>


                            <span>绑定并激活(人)</span>
                        </div>
                        <div>
                            <span class="tit">{{ rewardInfo.money || 0 }}</span>
                            <span>累计获得奖励</span>

                            <span> (人民币)</span>
                        </div>
                        <div>
                            <span class="tit">{{ rewardInfo.invitenum || 0 }}</span>

                            已绑定邀请(人)
                            <span></span>
                        </div>
                    </div>
                    <div class="rewards">
                        <p>奖励明细</p>
                        <img v-if="showReward" class="cart" @click="toReward" src="/subject/frendbonst/function/top.png"
                            alt="" />
                        <img class="cart" v-else src="/subject/frendbonst/function/down.png" @click="toReward" alt="" />
                        <div v-show="showReward" class="tabledate">
                            <el-table :data="tableData" style="width: 100%" height="200"
                                :header-cell-style="{ textAlign: 'center' }"
                                :cell-style="{ textAlign: 'center', color: '#959595' }">
                                <el-table-column prop="gettime" label="获得时间" width="140">
                                    <template slot-scope="scope">
                                        {{ getDateChange(scope.row.gettime + 8 * 60 * 60 * 1000) }}

                                    </template>

                                </el-table-column>
                                <el-table-column prop="money" label="发放金额" width="100" :show-overflow-tooltip="true">
                                </el-table-column>
                                <el-table-column prop="status" label="奖金状态">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.status == 1">锁定中</span>
                                        <span v-else-if="scope.row.status == 2">可提现</span>
                                        <span v-else-if="scope.row.status == 3">已发放</span>
                                        <span v-else-if="scope.row.status == 4">发放失败</span>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </div>

                    </div>
                </div>


            </div>

        </div>
        <el-dialog :visible.sync="shareDialog" :showClose="false" width="96%" height="50px" custom-class="loginDialogs">
            <div id="sharetypes">
                <img src="/subject/frendbonst/function/poster.png" style="width: 100%;height: auto;" alt="">
                <img src="/subject/frendbonst/function/save1.png" class="savePoster" alt="">
                <!-- <img src="/subject/frendbonst/function/save.png" class="savePoster" v-else @click="downloadsImg" alt=""> -->
                <div class="sharebottom">

                    <Qrcode :link="shareTypesUrl" :size="80" :iconSize="30" />
                </div>
            </div>
        </el-dialog>
        <!-- 活动规则 -->
        <div class="popup" v-if="controlPop">
            <span @click="closePop" class="closer1">X</span>
            <ul class="popContent">
                <li class="top-tit">
                    真金酬知己 荐面三重礼
                </li>
                <li class="top-cont">
                    邀好友赚赏金，成星级合伙人，月月收美金！
                </li>


                <li>
                    <span>人民币礼金三重奏 美元分红引爆推荐热潮</span><br />
                    <span>活动时间：长期有效</span><br />
                    <span>参与条件：本平台真实入金激活用户</span><br />
                    <span>第一重：即刻见面礼</span><br />
                    条件：好友通过您的专属链接注册并激活<br />
                    奖励：立即获得 188元 现金红包<br />
                    小贴士：无需等待，激活即得


                </li>
                <li>
                    <span>第二重：成长鼓励礼</span><br />

                    条件：您的好友在有效期内完成1手有效交易<br />
                    奖励：获得 188元 现金红包<br />
                    小贴士：快来助力好友迈出交易1小步


                </li>
                <li>
                    <span>
                        第三重：战队建设礼
                    </span><br />
                    条件：成功推荐有效邀请人5人，组建专属战队<br />
                    奖励：除了获得以上所有奖励外，额外赠送888元 现金奖励 + 晋升【推广之星】<br />
                    小贴士：从个人推广到团队建设的华丽蜕变<br />
                    推荐越多，赚得越多！5人一组，组组皆明星<br />

                </li>
                <li>

                    <table>
                        <tr>
                            <th>奖励类型</th>
                            <th>条件</th>
                            <th>邀请人获得(RMB)</th>
                            <th>邀请人提取要求</th>


                        </tr>
                        <tr>
                            <th>好友注册奖励</th>

                            <th>好友通过专属链接注册并激活</th>
                            <th>188元</th>
                            <th>30天内提取</th>


                        </tr>
                        <tr>
                            <th>好友交易奖励</th>
                            <th>好友在有效期内完成1手有效交易</th>
                            <th>188元</th>

                            <th>30天内提取</th>



                        </tr>
                        <tr>
                            <th>有效邀请5人</th>
                            <th>5个邀请人在有效期内完成首入并完成5手</th>
                            <th>888元</th>

                            <th>30天内提取</th>


                        </tr>
                        <tr>
                            <th>5人组队福利汇总</th>
                            <th>376*5+888</th>
                            <th>2768元</th>

                            <th></th>


                        </tr>

                    </table>
                </li>
                <li>
                    <span>推广之星 专属红利返赠</span>

                </li>

                <li>

                    <table>
                        <tr>
                            <th>层级</th>
                            <th>要求</th>
                            <th>月交易手数(总和)</th>
                            <th>每手返赠</th>
                        </tr>
                        <tr>
                            <th>L1</th>
                            <th>推广有效好友5人及以上</th>
                            <th>5≤N≤50</th>
                            <th>5美金</th>
                        </tr>
                        <tr>
                            <th>L2</th>
                            <th>推广有效好友8人及以上</th>
                            <th>50&lt;N≤500</th>
                            <th>8美金</th>
                        </tr>
                        <tr>
                            <th>L3</th>
                            <th>推广有效好友12人及以上</th>
                            <th>500以上</th>
                            <th>10美金</th>
                        </tr>


                    </table>
                    升级为「红狮推广伙伴」，专属BD经理服务，享受更多红利权益保障<br />
                    <span>

                        小贴士：所有返赠按月发放，可绑定钱包提领到账。等级动态更新，次月重新评估。
                    </span>
                </li>

                <li>
                    <span>推荐方式</span>
                    <br /> ① 推荐人可复制分享链接或保存邀请海报，通过微信、QQ、邮箱等方式发送给好友，好友在专属推荐链接内开立真实账户即可完成推荐（如果遇到开启异常，可以复制链接到浏览器打开）
                    <br />② 推荐人将邀请码发送给好友，好友开立真实账户后，在用户中心内绑定邀请码后即可完成推荐。
                    <span>活动奖励：</span>
                    <br /> 人民币现金奖励：前往平台APP——我的——我的钱包 或 钱包余额 查看
                    <br />若逾期未完成交易要求或逾期未提现，视为自动放弃奖励权益，奖励将被回收 。
                    <br />美金返赠奖励：美金返赠周期是被推荐人注册后的90天内关系有效。每月 1 - 7 日，平台对上月所有分享奖励达标情况集中审核（含好友身份有效性、交易真实性等
                    ），审核通过后，奖励正式发放至对应交易账户，到账后可自由选择提现或继续用于交易操作 。
                </li>
                <li>
                    <span>注意事项</span><br />
                    1. 参加原邀请好友活动的客户按照原活动规则执行，如有疑问请咨询客服；<br />
                    2.
                    参与活动的双方，需接受平台审核，如有异常套利恶意滥用平台政策者，双方都将取消奖励和参与资格；同一真实交易账户不可被多次邀请；每位被推荐人仅和1位推荐人绑定关系，超过3个月未交易者，绑定关系自动结束；<br />
                    3. 新户首入低于50美金无法参加本活动；交易手数的计算：本活动全品种手数可参与计算，开仓一手再平仓一手，如此来回为一手；<br />
                    4. 我平台保留随时修订、暂停、终止本活动及相关规则条款之权利及解释权。<br />
                    5.若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Qrcode from "@/component/QrCode/index.vue";
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import html2canvas from "html2canvas";

import { postFriendAssist, getActicityParam } from "@/apis/transfer";
import { encryptCBC } from "@/utils/IMEI";
import { bindCrmFriendHelpActivity } from "@/apis/active";
import { copyText } from "@/utils/tools";


export default {
    components: {

        Qrcode,
    },
    mixins: [userSign],

    data() {
        return {

            scroll: "",
            screenWidth: null,
            timer: null,
            tableData: [

            ],


            isApp: false,

            isPC: true,

            fullscreenLoading: false,

            userinfo: {},
            activeCont: {},
            contInfos: {},
            joinList: [],//参与活动
            isLogin: false,//App端是否有Token
            queryInfo: {},//传递数据
            showState: false,//结束展示阶段一/阶段2
            showReward: false,
            inviteType: 2,
            inviteLink: '',
            inviteCode: '',
            shareDialog: false,
            shareTypesUrl: '',
            rewardInfo: {},
            inviteeCode: '',
            inviteTypes: false,
            controlPop: false


        };
    },

    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };




    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                this.$emit("controlShow", false);

            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);


        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            this.queryInfo = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.isPC = false
            }


            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)
            if (token) {
                const str = this.$route.query.isApp
                this.isLogin = true
                localStorage.setItem('account', this.$route.query.a);
                this.userKey = localStorage.getItem('token');
                this.getJoin()

            } else {
                this.isLogin = false
            }
        }



    },
    methods: {
        ...mapActions('common', {
            getTradeWapLink: 'getTradeWapLink',
        }),
        // 获取信息
        getInfo() {
            const iv = 'shmfdWQyrLRFBNXK';
            // 是否有进行中的活动
            let initData = {
                platform: 1
            }

            postFriendAssist('isactivity', { data: encryptCBC(JSON.stringify(initData), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('是否有进行中的活动', res)
                if (res.status == 0) {
                    this.getActivity(res.content)


                } else {
                    if (this.inviteTypes) {
                        this.$message.error(res.message)

                    }


                }

            })





        },
        getActivity(res) {
            const iv = 'shmfdWQyrLRFBNXK';


            let params = {
                "activityid": res.activityid,
                "platform": 1,
                accountid: localStorage.getItem('account'),

                // "accountid": 85007732
            }
            console.log(params)
            // 奖励详情
            postFriendAssist('rewardDetail', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('奖励详情', res)
                if (res.status == 0) {
                    this.rewardInfo = res.content ? res.content : {}
                }

            })
            postFriendAssist('friendusercenter', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('用户中心', res)
                if (res.inviterCode) {


                    this.tableData = res.content ? res.content.prizeInfos : []


                    this.inviteCode = res.inviterCode ? res.inviterCode : ''

                    this.inviteLink = res.inviterCode ? this.queryInfo.fromUrl ? this.queryInfo.fromUrl + '/specialEvents/invite-reward/newRegister?utm_source=zzjz&t=2&tg=' + res.inviterCode + '&type=newinvite' : 'https://h5pro.rlc562.com/specialEvents/invite-reward/newRegister?utm_source=zzjz&t=2&tg=' + res.inviterCode + '&type=newinvite' : ''

                    this.shareTypesUrl = res.inviterCode ? this.queryInfo.fromUrl ? this.queryInfo.fromUrl + '/specialEvents/invite-reward/newRegister?utm_source=zzjz&t=2&tg=' + res.inviterCode + '&type=newinvite' : 'https://h5pro.rlc562.com/specialEvents/invite-reward/newRegister?utm_source=zzjz&t=2&tg=' + res.inviterCode + '&type=newinvite' : ''

                }



            })
        },

        // 活动结束查询活动
        getJoin() {
            const iv = 'LIQABxPFN04DhnkX';
            const params = {
                accountid: localStorage.getItem('account'),

            }
            getActicityParam('findbyaccountid', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('用户信息-------', res)
                if (res.activityuserinfos && res.activityuserinfos.length > 0) {
                    // 查询用户是否参加过如果参加过直接展示信息
                    let list = res.activityuserinfos

                    let status = list.find(item => item.code == 'FriendA')
                    let lastCodeMap = {};
                    for (let i = 0; i < list.length; i++) {
                        for (let j = 0; j < list.length; j++) {
                            if (list[i].code == list[j].code) {
                                lastCodeMap = list[j]
                            }
                        }
                    }
                    if (status && lastCodeMap.activityid) {


                        this.getActivity(lastCodeMap)
                    }
                    else if (status) {
                        list.map(item => {
                            if (item.code == FriendA) {
                                lastCodeMap = item
                            }
                        })
                        this.getActivity(lastCodeMap)
                    }

                    else {

                        this.inviteTypes = true
                        this.getInfo()
                    }




                }
                else {
                    this.inviteTypes = true

                    this.getInfo()

                }


            })
        },

        getIsInvited() {
            const iv = 'shmfdWQyrLRFBNXK';
            let params = {

                "platform": 1,
                inviteeid: localStorage.getItem('account'),
            }
            postFriendAssist('isinvited', { data: encryptCBC(JSON.stringify(params), 'Uk6pqN80hgFbbC7a', iv), iv }).then(res => {
                console.log('是否被邀请', res)
            })

        },


        // 参加活动
        joinActivity() {

        },

        // 客服链接
        live800() {
            window.open(
                this.live800UrlUc
            );
        },

        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度

            let scrollY = window.scrollY; //获取滚动后的高
            if (this.scroll > 90) {

            } else {

            }


        },

        goback() {

        },
        toReward() {
            this.showReward = !this.showReward
        },
        //复制
        copyChange(type) {
            if (type == 1) {
                if(this.inviteLink==''){
                    this.$message.error('请先完成激活账户！')
                    return
                }
                copyText(this.inviteLink);
                this.$message.success('复制成功~')

            } else {
                if(this.inviteCode==''){
                    this.$message.error('请先完成激活账户！')
                    return
                }
                copyText(this.inviteCode);
                this.$message.success('复制成功~')
            }
        },
        // 生成海报
        createPoster() {
            if(this.shareTypesUrl==''){
                this.$message.error('请先完成激活账户！')
                return
            }
            this.shareDialog = true
        },
        // 下载海报
        downloadsImg() {
            html2canvas(document.getElementById("sharetypes"), {
                useCORS: true, //是否尝试使用CORS从服务器加载图像
                backgroundColor: 'null', //画布背景色（如果未在DOM中指定）。设置null为透明
            }).then((canvas) => {
                // 转化成 dataurL
                let canvasImg = canvas.toDataURL("image/png");
                //调用下载方法
                if (this.isApp) {
                    if (window.android) {
                        window.android.onSaveUrlImage(canvasImg);
                        return
                    }
                    // 在ios
                    if (window.webkit) {
                        window.webkit.messageHandlers.onSaveUrlImage(canvasImg);
                        return
                    }

                } else {
                    this.downLoadFile("poster", canvasImg);
                }
            });

            this.shareDialog = false


        },
        downLoadFile(fileName, canvasImg) {
            //创建一个a标签
            var a = document.createElement("a");
            //指定下载文件名称
            a.href = canvasImg;
            a.download = fileName;
            //模拟点击
            a.click();
        },
        // 时间戳转时间
        getDateChange(date) {
            var t = new Date(date).toLocaleString();
            return t;
        },
        // 切换邀请类型
        changeType() {
            this.inviteType = this.inviteType == 1 ? 2 : 1
        },
        // 绑定好友
        bindFriend() {
            if (this.inviteeCode == '') {
                this.$message.error('请输入好友邀请码')
                return
            }
            let params = {
                inviteeBindHelpCode: this.inviteeCode,
            }

            bindCrmFriendHelpActivity(params).then(res => {
                console.log('绑定好友', res)
                if (res == '邀请成功') {
                    this.$message.success('绑定成功')
                    this.inviteeCode = ''
                } else {
                    this.$message.error(res.Data)
                }

            })

        },
        closePop() {
            this.controlPop = false
        },

    },

    computed: {
        ...mapState("common", {
            live800UrlUc: 'live800UrlUc',
        }),
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 30%;
    margin: 0 auto;
    height: 566px;
    position: relative;
    .rule {
        position: absolute;
        top: 20%;
        right: 0%;
        width: 6%;
        height: auto;
    }

    .banner {
        width: 100%;
    }

    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;

        background: url(/subject/frendbonst/function/bg.png) no-repeat;
        background-size: 100% 100%;


        .part {
            // max-width: 1400px;
            width: 100%;
            margin: 0 auto;
            padding: 9% 0% 10%;

            .carts {
                width: 100%;
                height: auto;
                margin: 0 auto;
                padding: 0 2%;
                box-sizing: border-box;

            }





            .tabledate {
                width: 100%;
            }

            .cart1 {
                background: url(/subject/frendbonst/function/bg1.png) no-repeat;
                background-size: 100% 100%;
                position: relative;
                width: 100%;
                // height: 200px;

                .recommen {
                    position: absolute;
                    top: 22%;
                    right: 6%;
                    width: 6%;
                    height: auto;
                }

                .invitecont {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    font-size: 16px;
                    font-weight: 600;
                    padding: 2rem 4%;

                    img {
                        width: 60%;
                        height: auto;
                    }

                    .invitecode {
                        margin: 10px 0;
                        padding: 10px 0px;
                        background: #fff2e0;
                        border: none;
                    }

                    .tips {
                        color: #ef9a39;
                        margin-top: 10px;
                    }
                }

                .inviteconts {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 600;
                    padding: 2rem 4%;
                    margin: 0 auto;

                    .invitercont {
                        position: relative;
                    }

                    .copy {
                        width: 17px;
                        height: 20px;
                        position: absolute;
                        top: 20px;
                        right: 14px;
                        background: #fff;
                    }

                    img {
                        width: 60%;
                        height: auto;

                    }

                    .invitecode {
                        margin: 10px;
                        padding: 10px 4px;
                        background: #fff2e0;
                        border: none;
                    }

                    .inviter {
                        margin-left: 20px;
                    }


                }
            }

            .cart2 {
                background: url(/subject/frendbonst/function/bg3.png) no-repeat;
                background-size: 100% 100%;
                padding: 2% 4% 4%;
                position: relative;

                .rewards {
                    display: flex;
                    align-items: center;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 600;
                    flex-direction: column;
                    justify-content: center;
                    margin-top: 20px;

                    img {
                        width: 8%;
                        height: auto;
                        margin: 4% 0;
                    }

                    /deep/ .el-table__header-wrapper {

                        border-radius: 20px !important;
                    }

                    /deep/ .el-table__header-wrapper tr th {
                        background: #fff2e0 !important;

                    }

                    /deep/ .el-table {
                        border-radius: 20px !important;

                    }
                }

                .rule {
                    position: absolute;
                    top: 0;
                    left: 30%;
                    width: 40%;
                    height: auto;
                }

                .ledgers {
                    background: url(/subject/frendbonst/function/bg2.png) no-repeat;
                    background-size: 100% 100%;
                    display: flex;

                    justify-content: space-between;
                    padding: 14% 6% 4%;

                    div {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 16px;
                        font-weight: 600;

                        .tit {
                            color: #e65228;
                            margin-bottom: 10px;
                            font-size: 16px;
                        }
                    }
                }

            }

        }





    }

    #sharetypes {
        position: relative;
        width: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .savePoster {
        position: absolute;
        bottom: 4%;
        right: 10%;
        width: 80%;
    }

    .sharebottom {
        position: absolute;
        bottom: 18%;
        right: 10%;
    }

    /deep/ .loginDialogs {
        width: 30% !important;
    }

    /deep/ .el-dialog__body {
        padding: 0 !important;
    }

    /deep/ .el-dialog__header {
        padding: 0 !important;
    }
 .popup {
     overflow-x: hidden;
     width: 28%;
     height: 900px;
     border-radius: 20px;
     background: #fdf5e6;
     position: fixed;
     top: 57%;
     left: 50%;
     transform: translate(-50%; -50%);
     box-sizing: border-box;
     padding: 10px;
     box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
     overflow-y: scroll;
     padding-bottom: 40px;
     z-index: 99999999999999;

     .closer1 {
         float: right;
         cursor: pointer;
         margin-top: 8px;
         margin-right: 10px;
     }

     .popContent {
         box-sizing: border-box;
         padding: 40px 50px 20px;

         .top-tit {
             font-weight: 600;
             color: #000;
             font-size: 30px;
             margin-bottom: 30px;
         }

         li {
             font-size: 18px;
             color: #a86e4f;
             line-height: 36px;

             span {
                 font-weight: 600;
                 color: #e34a3f;
             }

             img {
                 width: 100%;
                 height: auto;
                 margin: 20px 0;
             }

             table {
                 border: 1px solid #e34a3f;
                 border-radius: 15px;
                 width: 100%;

                 tr {
                     th {
                         text-align: center;
                         font-weight: 500;
                         line-height: 50px;
                         border-bottom: 1px solid #d2a765;
                         border-right: 1px solid #d2a765;
                         padding: 5px;
                     }

                     th:last-child {
                         border-right: 1px solid transparent;
                     }
                 }

                 tr:nth-child(1) {
                     th {
                         font-weight: 600;
                     }
                 }
             }
         }
     }
 }

}




@media screen and (max-width: 500px) {
    .box {
        width: 100%;

        .banner {
            width: 100%;
        }

        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/frendbonst/function/bg.png) no-repeat;
            background-size: 100% 100%;

            margin-top: -3%;

            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 0% 2% 10%;

                .carts {
                    width: 100%;
                    height: auto;
                }

                .tabledate {
                    width: 100%;
                }

                .cart1 {
                    background: url(/subject/frendbonst/function/bg1.png) no-repeat;
                    background-size: 100% 100%;
                    position: relative;
                    width: 100%;
                    // height: 200px;

                    .recommen {
                        position: absolute;
                        top: 22%;
                        right: 6%;
                        width: 6%;
                        height: auto;
                    }

                    .invitecont {
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        font-size: 12px;
                        font-weight: 600;
                        padding: 1.5rem 4%;

                        img {
                            width: 60%;
                            height: auto;
                        }

                        .invitecode {
                            margin: 10px 0;
                            padding: 10px 0px;
                            background: #fff2e0;
                            border: none;
                        }

                        .tips {
                            color: #ef9a39;
                            margin-top: 10px;
                        }
                    }

                    .inviteconts {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 12px;
                        font-weight: 600;
                        padding: 1.5rem 4%;
                        margin: 0 auto;

                        .invitercont {
                            position: relative;
                        }

                        .copy {
                            width: 17px;
                            height: 20px;
                            position: absolute;
                            top: 20px;
                            right: 14px;
                            background: #fff;
                        }

                        img {
                            width: 60%;
                            height: auto;

                        }

                        .invitecode {
                            margin: 10px;
                            padding: 10px 4px;
                            background: #fff2e0;
                            border: none;
                        }

                        .inviter {
                            margin-left: 20px;
                        }


                    }
                }

                .cart2 {
                    background: url(/subject/frendbonst/function/bg3.png) no-repeat;
                    background-size: 100% 100%;
                    padding: 2% 4% 4%;
                    position: relative;

                    .rewards {
                        display: flex;
                        align-items: center;
                        color: #fff;
                        font-size: 14px;
                        font-weight: 600;
                        flex-direction: column;
                        justify-content: center;
                        margin-top: 20px;

                        img {
                            width: 8%;
                            height: auto;
                            margin: 4% 0;
                        }

                        /deep/ .el-table__header-wrapper {

                            border-radius: 20px !important;
                        }

                        /deep/ .el-table__header-wrapper tr th {
                            background: #fff2e0 !important;

                        }

                        /deep/ .el-table {
                            border-radius: 20px !important;

                        }
                    }

                    .rule {
                        position: absolute;
                        top: 0;
                        left: 30%;
                        width: 40%;
                        height: auto;
                    }

                    .ledgers {
                        background: url(/subject/frendbonst/function/bg2.png) no-repeat;
                        background-size: 100% 100%;
                        display: flex;

                        justify-content: space-between;
                        padding: 14% 6% 4%;

                        div {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 600;

                            .tit {
                                color: #e65228;
                                margin-bottom: 10px;
                                font-size: 16px;
                            }
                        }
                    }

                }

            }
        }

 


        #sharetypes {
            position: relative;
        }

        .savePoster {
            position: absolute;
            bottom: 4%;
            right: 10%;
            width: 80%;
        }

        .sharebottom {
            position: absolute;
            bottom: 18%;
            right: 10%;
        }

        /deep/ .loginDialogs {
            width: 96% !important;
        }

        /deep/ .el-dialog__body {
            padding: 0PX !important;
        }

        /deep/ .el-dialog__header {
            padding: 0 !important;
        }
                .popup {
                    position: relative;
                    position: fixed;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 95%;
                    height: 480px;
                    box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
                    background-color: #fdf5e6;
                    border-radius: 15px;
                    overflow-y: scroll;
                    z-index: 99999999;
        
                    .closer1 {
                        width: 16px;
                        height: 30px;
                        height: auto;
                        position: absolute;
                        top: 5px;
                        right: 5px;
                        font-size: 20px;
                    }
        
                    .popContent {
                        box-sizing: border-box;
                        padding: 10px;
                        overflow: hidden;
        
                        .top-tit {
                            font-size: 16px;
                            margin-top: 20px;
        
                        }
        
                        li {
                            font-size: 14px;
                            color: #a86e4f;
                            line-height: 24px;
        
                            span {
                                font-weight: 600;
                                color: #e34a3f;
                            }
        
                            img {
                                width: 100%;
                                height: auto;
                                margin: 20px 0;
                            }
        
                            table {
                                width: 100%;
                                border: 1px solid #e34a3f;
                                border-radius: 10px;
        
                                tr {
                                    th {
                                        text-align: center;
                                        font-weight: 500;
                                        line-height: 24px;
                                        border-bottom: 1px solid #d2a765;
                                        border-right: 1px solid #d2a765;
                                        padding: 5px;
                                    }
        
                                    th:last-child {
                                        border-right: 1px solid transparent;
                                    }
                                }
        
                                tr:nth-child(1) {
                                    th {
                                        font-weight: 600;
                                    }
                                }
                            }
                        }
                    }
                }

    }

}
</style>
